import { userConstants } from './../constants/user.constants';

const initialState = {};

export function GETINSTITUTE(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_INSTITUTE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GET_INSTITUTE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GET_INSTITUTE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function CREATEPRODUCT(state = initialState, action) {
  switch (action.type) {
    case userConstants.POST_INSTITUTE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.POST_INSTITUTE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.POST_INSTITUTE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}
export function GETPRODUCTS(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCTS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GET_PRODUCTS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GET_PRODUCTS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}